class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    
    document.querySelector('.header__menu-item')
      .addEventListener('mouseover', this.onSummaryClick.bind(this));

    document.querySelector('#MegaMenu-Content-1').focus()

    document.querySelector('details').addEventListener('mousemove',this.close())
    document.querySelector('details').addEventListener('mouseout',this.close())
    document.querySelector('details').addEventListener('focusout', this.close())

        document.body.addEventListener('click',function(){ document.querySelector('details').removeAttribute('open'); })

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.addEventListener(
      'mouseover',
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.addEventListener(
        'mouseover',function (event) {
              event.target.closest('details').setAttribute('open', true);

        }
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.querySelector('button[type="button"]').addEventListener(
      'mouseover',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);

    
    event.querySelector('#MegaMenu-Content-1').focus()
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) 
      this.close();
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    
    document.body.classList.add('overflow-hidden');

   


    setInterval(function(){
      document.querySelector('details').removeAttribute('open');
    }, 4000)
  
    document.querySelector('#MegaMenu-Content-1').focus()
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    
    
    document.body.classList.remove('overflow-hidden');

  
    
  }
}

customElements.define('details-modal', DetailsModal);
